import { Injectable } from '@angular/core';
import { SourceSystemType, ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { ITransactionSummary } from './itransaction-summary.interface';

@Injectable()
export abstract class TransactionSummaryService implements ITransactionSummary {
    protected sourceSystemTypes: SourceSystemType = new SourceSystemType();

    /**
     * Returns the source system type for the route builder
     */
    public abstract get sourceSystemType(): ISourceSystemType;

    public abstract parseTransaction(transactionObject: any, transactionTypeId: number);

    format(formatString: string, args: string[]) {
        return formatString.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
            ;
        });
    }
}
